export const blockIconsNavigationUnfoldMore = (
	<span className='material-symbols-outlined'>unfold_more</span>
);
